import './App.css';

function App() {
  return (
    <div className="App">
      <div className="landing-container">
        <div className="left-section">
          <div className="logo-container">
            <img 
              src="/fm-rainbow-logo.jpeg" 
              className="logo" 
              alt="FM Rainbow Logo" 
            />
          </div>
          <div className="content">
            <h1 className="main-heading">
              Something exciting is coming soon...
            </h1>
            <div className="dots">
              <span className="dot"></span>
              <span className="dot"></span>
              <span className="dot"></span>
            </div>
          </div>
          <div className="rainbow-line"></div>
        </div>
        
        <div className="right-section">
          <div className="fisherman-container">
            <img 
              src="/fm-cover.png" 
              className="fisherman-image" 
              alt="Fisherman" 
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
